import * as CSS from 'csstype';
import { FiArrowLeft } from 'react-icons/fi';
import { renderIcon } from 'utils/icon.utils';
import './Button-back.scss';

interface ButtonBackProps {
  label: string;
  styleInLine?: CSS.Properties<string | number>;
  onClick: () => void;
  template: 'primary' | 'secondary';
  testid: string;
}

export const ButtonBack = ({
  testid,
  styleInLine,
  template,
  onClick,
  label,
}: ButtonBackProps) => {
  return (
    <button
      data-testid={testid}
      style={styleInLine}
      className={`button__back ${
        template === 'secondary' ? 'button__back--secondary' : ''
      }`}
      onClick={onClick}
    >
      {renderIcon(FiArrowLeft, { className: 'button__back__icon' })}
      {label}
    </button>
  );
};
